import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['slide'];

  connect() {
    let number = 0;
    this.intervalHandle = setInterval(() => {
      if (!this.hasSlideTarget) return;
      const images = this.slideTargets;
      const next = (number + 1) % this.slideTargets.length;
      images[next].classList.remove("hidden");
      images[next].classList.add("z-10");
      setTimeout(() => {
        if (!this.hasSlideTarget) return;
        images[number].classList.add("hidden");
        images[next].classList.remove("z-10");
        number = next;
      }, 50);
    }, 5000);
  }

  disconnect() {
    clearInterval(this.intervalHandle);
  }
}
